import { defineNuxtPlugin } from '#app'

import { ComentariosMGRowModalSidebarType } from '@comentarios_mg/rowModalSidebarTypes'
import {
  AvisoComentarioNotificationType,
  AvisoMencionNotificationType,
} from '@comentarios_mg/notificationTypes'

export default defineNuxtPlugin({
  name: 'comentarios-mg',
  dependsOn: ['core', 'database', 'premium'],
  setup(nuxtApp) {
    const { $registry } = nuxtApp
    const context = { app: nuxtApp }

    // La edicion premium registra su propia pestana "Comentarios", que sin
    // licencia solo pinta el anuncio de "disponible en la version premium".
    // Aqui se quita para no dejar dos pestanas de comentarios en la misma fila.
    //
    // El 'premium' del dependsOn de arriba NO es decorativo: que el modulo se
    // cargue al final (nuxt.config.base.ts concatena ADDITIONAL_MODULES) no
    // ordena los plugins, eso lo hace dependsOn. Sin el, este plugin corre antes
    // que premium —queda listo con core y database, mientras premium ademas
    // espera builder y client-handler—, exists() da falso, no se quita nada y la
    // pestana premium aparece igual. Se vio en pantalla contra datos reales.
    // La guarda se queda por si el registro cambia; con premium siempre cargado
    // (no se usa BASEROW_OSS_ONLY) la rama falsa no deberia darse.
    if ($registry.exists('rowModalSidebar', 'comments')) {
      $registry.unregister('rowModalSidebar', 'comments')
    }

    $registry.register(
      'rowModalSidebar',
      new ComentariosMGRowModalSidebarType(context)
    )

    // Aviso en la campana cuando alguien comenta una fila en la que participas.
    $registry.register(
      'notification',
      new AvisoComentarioNotificationType(context)
    )

    // Y uno aparte, mas fuerte, cuando te mencionan con "@".
    $registry.register('notification', new AvisoMencionNotificationType(context))
  },
})
